import { FC, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { AngularModalDimmer } from 'src/components/angular-modal-dimmer';
import { HeaderPrimary } from 'src/components/header/primary';
import { HeaderSecondary } from 'src/components/header/secondary';
import { isAggregateEuActive } from 'src/components/header/secondary-nav-aggregate-eu';
import { isDashboardActive } from 'src/components/header/secondary-nav-dashboard';
import { isGdmActive } from 'src/components/header/secondary-nav-gdm';
import { isLngActive } from 'src/components/header/secondary-nav-lng';
import { isReportingActive } from 'src/components/header/secondary-nav-reporting';
import { isStorageActive } from 'src/components/header/secondary-nav-storage';
import { isTransportActive } from 'src/components/header/secondary-nav-transport';
import { SimpleHeader } from 'src/components/simple-page-layout';
import { Successful } from 'src/hooks/use-axios';
import { useOptionalMonolithCurrentUser } from 'src/hooks/use-monolith-user';
import {
  OrganisationServiceRequest,
  useOrganisationServiceIfAuthenticated,
} from 'src/pages/settings/organisation/use-organisation-service';

type HeaderProps = {
  isSnamAdmin?: boolean;
};

export const Header: FC<HeaderProps> = (props) => {
  const { isSnamAdmin } = props;

  const { pathname, hash } = useLocation();
  const auth = useOptionalMonolithCurrentUser();

  const activeSection = useMemo(() => {
    const dashboard = isDashboardActive(pathname, hash, auth?.role);
    const transport = isTransportActive(pathname, hash);
    const storage = isStorageActive(pathname, hash, auth);
    const lng = isLngActive(pathname, hash, auth);
    const reporting = isReportingActive(pathname, hash);
    const gdm = isGdmActive(pathname);
    const aggregateEu = isAggregateEuActive(pathname);
    return { dashboard, transport, storage, reporting, gdm, lng, aggregateEu };
  }, [pathname, hash, auth]);

  const organisationService = useOrganisationServiceIfAuthenticated();

  if (
    organisationService.response === null &&
    organisationService.error === null
  )
    return <SimpleHeader />;

  return (
    <AngularModalDimmer id="react-header">
      <header>
        <HeaderPrimary
          activeSection={activeSection}
          organisationService={
            organisationService.response === null
              ? undefined
              : (organisationService as Successful<OrganisationServiceRequest>)
          }
        />
        <HeaderSecondary
          isSnamAdmin={isSnamAdmin}
          activeSection={activeSection}
        />
      </header>
    </AngularModalDimmer>
  );
};
